// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of all experiences ID.
 * By convention the experience ID ***MUST*** match exactly (including case) the class name for the experience.
 * NOTE: Keep this list alphabetical
 */
export enum ExperienceIds {
    animator = "Animator",
    articlePage = "ArticlePage",
    autosCard = "AutosCard",
    backgroundGradient = "BackgroundGradient",
    backgroundImageCommon = "BackgroundImageCommon",
    backgroundImageEdge = "BackgroundImageEdge",
    backgroundImageEdgeNext = "BackgroundImageEdgeNext",
    backgroundImageWC = "BackgroundImageWC",
    bannerManager = "BannerManager",
    baseHeader = "BaseHeader",
    bingAnswers = "BingAnswers",
    bingCards = "BingCardsExperience",
    bingHealth = "BingHealth",
    bingHealthCard = "BingHealthCard",
    bingShopping = "BingShopping",
    bingShoppingLifestyleCard = "BingShoppingLifestyleCard",
    bingShoppingMeStripe = "BingShoppingMeStripe",
    bingMiniShopping = "BingMiniShopping",
    bingVideoCard = "BingVideoCard",
    bingVideoCarousel = "BingVideoCarousel",
    bingWebSSO = "BingWebSSO",
    blowout = "Blowout",
    breakingNews = "BreakingNews",
    calendarCard = "CalendarCard",
    breakingNewsWC = "BreakingNewsWC",
    cardAction = "CardAction",
    cardActionV2 = "CardActionV2",
    cardActionWC = "CardActionWC",
    coachmark = "Coachmark",
    coachmarkWC = "CoachmarkWC",
    coldStart = "ColdStart",
    coldStartWC = "ColdStartWC",
    coldStartUpsellCard = "ColdStartUpsellCard",
    clarity = "Clarity",
    comments = "Comments",
    commonHeader = "CommonHeader",
    complexContentPreview = "ComplexContentPreview",
    conditionalBanner = "ConditionalBanner",
    conditionalBannerWC = "ConditionalBannerWC",
    contentPreview = "ContentPreview",
    contentProvider = "ContentProvider",
    contentRelated = "ContentRelated",
    contentActionsToolbar = "ContentActionsToolbar",
    contentSharingToolbar = "ContentSharingToolbar",
    cookieWall = "CookieWall",
    covidChatBot = "CovidChatBot",
    dailyBrief = "DailyBrief",
    dailyBriefWC = "DailyBriefWC",
    dashboardFallback = "DashboardFallback",
    dashboardSettings = "DashboardSettings",
    denseCard = "DenseCard",
    desktopFeed = "DesktopFeed",
    desktopFeedEdgeNext = "DesktopFeedEdgeNext",
    desktopFeedEdgeNextWC = "DesktopFeedEdgeNextWC",
    desktopFeedSingleColumn = "DesktopFeedSingleColumn",
    desktopFeedWC = "DesktopFeedWC",
    displayAds = "DisplayAds",
    displayAdsWC = "DisplayAdsWC",
    displayAdsWithContentFallback = "DisplayAdsWithContentFallback",
    edgeChromiumPage = "EdgeChromiumPage",
    edgeHeader = "EdgeHeader",
    edgeNextPage = "EdgeNextPage",
    edgePage = "EdgePage",
    edgePageSettings = "PageSettings",
    editorsChoicePromoCard = "EditorsChoicePromoCard",
    electionDelegateCounter = "ElectionDelegateCounter",
    electionEditorsNote = "ElectionEditorsNote",
    electionResultMap = "ElectionResultMap",
    electionResultsCard = "ElectionResultsCard",
    elections = "Elections",
    electionVisualizer = "ElectionVisualizer",
    enterpriseComplianceBanner = "EnterpriseComplianceBanner",
    enterpriseFeedContainer = "EnterpriseFeedContainer",
    enterpriseRightRail = "EnterpriseRightRail",
    enterpriseWaffle = "EnterpriseWaffle",
    entertainmentCard = "EntertainmentCard",
    entryPoint = "EntryPoint",
    entryPointEdgeNext = "EntryPointEdgeNext",
    entryPointOffice = "EntryPointOffice",
    esportsCard = "EsportsCard",
    esportsLivestreamCarouselWC = "EsportsLivestreamCarouselWC",
    eventHubHeroNav = "EventHubHeroNav",
    eventHubPage = "EventHubPage",
    externalContentPreview = "ExternalContentPreview",
    externalNativeAd = "ExternalNativeAd",
    familyCard = "FamilyCard",
    feedbackCard = "FeedbackCard",
    feedToggle = "FeedToggle",
    feedToggleWC = "FeedToggleWC",
    feedNavigationHp = "FeedNavigationHp",
    feedVisualizer = "FeedVisualizer",
    financeCurrencyConverter = "FinanceCurrencyConverter",
    firstPartyPage = "FirstPartyPage",
    flyoutCard = "FlyoutCard",
    feedbackDialog = "FeedbackDialog",
    feedbackDialogWC = "FeedbackDialogWC",
    feedbackLink = "FeedbackLink",
    feedEdgeNext = "FeedEdgeNext",
    feedNavigationHeader = "FeedNavigationHeader",
    financeCardCommon = "FinanceCardCommon",
    financeCompanyProfileCard = "FinanceCompanyProfileCard",
    financeDetailHeader = "FinanceDetailHeader",
    financeDetailComposition = "FinanceDetailComposition",
    financeDetailNavigation = "FinanceDetailNavigation",
    financeDetailPageV2 = "FinanceDetailPageV2",
    financeDiscoverySection = "FinanceDiscoverySection",
    financeFeeds = "FinanceFeeds",
    financeFinancialsCard = "FinanceFinancialsCard",
    financeKeyFactsCard = "FinanceKeyFactsCard",
    financeLandingPageV2 = "FinanceLandingPageV2",
    financeListLandingPage = "FinanceListLandingPage",
    financeMarketCard = "FinanceMarketCard",
    financeMarketStatus = "FinanceMarketStatus",
    financeNewsCard = "FinanceNewsCard",
    financeNewsContent = "FinanceNewsContent",
    financeDetailsCard = "FinanceDetailsCard",
    financeDetailsCardV2 = "FinanceDetailsCardV2",
    financeEarningsCalendarCard = "FinanceEarningsCalendarCard",
    financeEventsCalendarCard = "FinanceEventsCalendarCard",
    financeIndicesCard = "FinanceIndicesCard",
    financeL3OwnershipGraph = "FinanceL3OwnershipGraph",
    financeMarketMoversCard = "FinanceMarketMoversCard",
    financePortfolioList = "FinancePortfolioList",
    financeRecentlyViewedCard = "FinanceRecentlyViewedCard",
    financeRecommendationCard = "FinanceRecommendationCard",
    financeRecommendationCardV2 = "FinanceRecommendationCardV2",
    financeWatchlistCard = "FinanceWatchlistCard",
    financeWatchlistMiniView = "FinanceWatchlistMiniView",
    financeWatchlistListView = "FinanceWatchlistListView",
    financeWatchlistManagement = "FinanceWatchlistManagement",
    financeWatchlistPage = "FinanceWatchlistPage",
    financeWatchlistPageV2 = "FinanceWatchlistPageV2",
    financeSearchBox = "FinanceSearchBox",
    financeFollowButton = "FinanceFollowButton",
    financeTrendCard = "FinanceTrendCard",
    footerWindowsShell = "FooterWindowsShell",
    freMarketSelector = "FreMarketSelector",
    frequentSitesCard = "FrequentSitesCard",
    frequentSitesCardWC = "FrequentSitesCardWC",
    galleryPage = "GalleryPage",
    generalElections = "GeneralElections",
    gmailEmailPreview = "GmailEmailPreview",
    headerEdgeNext = "HeaderEdgeNext",
    headerNavigationLogo = "HeaderNavigationLogo",
    headerWindowsShell = "HeaderWindowsShell",
    hiddenContent = "HiddenContent",
    homePage = "HomePage",
    horoscopeAnswerCard = "HoroscopeAnswerCard",
    horoscopeAnswerCardWC = "HoroscopeAnswerCardWC",
    iframe = "IFrame",
    imageSearch = "ImageSearch",
    industryNewsCard = "IndustryNewsCard",
    infopane = "Infopane",
    interests = "Interests",
    interestsLeftRail = "InterestsLeftRail",
    interestsSearch = "InterestsSearch",
    interestsV1Wrapper = "InterestsV1Wrapper",
    interestsV2 = "InterestsV2",
    interestsV3 = "InterestsV3",
    interestsWC = "InterestsWC",
    languageToggle = "LanguageToggle",
    layoutSwitcher = "LayoutSwitcher",
    layoutToggle = "LayoutToggle",
    legacySharingToolbar = "LegacySharingToolbar",
    localNews = "LocalNews",
    localNewsViewCard = "LocalNewsViewCard",
    locationContentCard = "LocationContentCard",
    locationSelector = "LocationSelector",
    locationTime = "LocationTime",
    lottery = "Lottery",
    marketAggregator = "MarketAggregator",
    marketSelector = "MarketSelector",
    meControl = "MeControl",
    meStripe = "MeStripe",
    meStripeWC = "MeStripeWC",
    meetNow = "MeetNow",
    microsoftFeedCard = "MicrosoftFeedCard",
    microsoftEdgeWidget = "MicrosoftEdgeWidget",
    microsoftLogo = "MicrosoftLogo",
    microsoftNewsPage = "MicrosoftNewsPage",
    migrationConsent = "MigrationConsent",
    miniApps = "miniApps",
    mmxPage = "MMXPage",
    mnsCreatorDashboard = "MnsCreatorDashboard",
    modernRightRail = "ModernRightRail",
    moneyCard = "MoneyCard",
    moneyInfoCard = "MoneyInfoCard",
    moneyInfoCardWC = "MoneyInfoCardWC",
    mobileFeed = "MobileFeed",
    msnSettingMenu = "MsnSettingMenu",
    msRewards = "MsRewards",
    msRewardsWC = "MsRewardsWC",
    myBriefRiverCard = "MyBriefRiverCard",
    nativeAd = "NativeAd",
    newsbarFeed = "NewsbarFeed",
    notificationBell = "NotificationBell",
    notificationBellWC = "NotificationBellWC",
    office = "Office",
    officeContainer = "OfficeContainer",
    officeDocumentCard = "OfficeDocumentCard",
    officeDocumentsTable = "OfficeDocumentsTable",
    officeDocumentsTableWC = "OfficeDocumentsTableWC",
    officeLeftRail = "OfficeLeftRail",
    oneFooter = "OneFooter",
    overlay = "Overlay",
    outlookEmailPreview = "OutlookEmailPreview",
    onThisDayCard = "OnThisDayCard",
    onThisDayCardWC = "OnThisDayCardWC",
    pageRefresh = "PageRefresh",
    partnerUpsellCard = "PartnerUpsellCard",
    partnerWidget = "PartnerWidget",
    personalizeNavButton = "PersonalizeNavButton",
    photoCard = "PhotoCard",
    pivotContent = "PivotContent",
    pivotContentV2 = "PivotContentV2",
    pivotsNav = "PivotsNav",
    pivotsNavV2 = "PivotsNavV2",
    pivotsNavEdgeNext = "PivotsNavEdgeNext",
    pollsCard = "PollsCard",
    pollsCardWC = "PollsCardWC",
    portugueseElectionExperience = "PortugueseElectionExperience",
    poweredByLegend = "PoweredbyLegend",
    poweredByLegendWC = "PoweredbyLegendWC",
    proactiveCanvas = "ProactiveCanvas",
    productivityHub = "ProductivityHub",
    productivityHubContainer = "ProductivityHubContainer",
    promoBanner = "PromoBanner",
    publisherCarousel = "PublisherCarousel",
    publishersManagement = "PublishersManagement",
    qna = "Qna",
    qnaFeedPage = "QnaFeedPage",
    qnaFeedCard = "QnaFeedCard",
    qnaFeedCardMenu = "QnaFeedCardMenu",
    qnaFeedCategoriesMenu = "QnaFeedCategoriesMenu",
    qnaFeedList = "QnaFeedList",
    qnaFeedMyTopics = "QnaFeedMyTopics",
    qnaFeedRelatedQuestions = "QnaFeedRelatedQuestions",
    qnaFeedReportCard = "QnaFeedReportCard",
    qnaFeedSuggestedTopics = "QnaFeedSuggestedTopics",
    qnaFeedTopicDetail = "QnaFeedTopicDetail",
    qnaFeedTrendingQuestions = "QnaFeedTrendingQuestions",
    recipesCards = "RecipesCards",
    recipesFeed = "RecipesFeed",
    recipesSdCard = "RecipesSdCard",
    recipesSearch = "RecipesSearch",
    recipesSingleDetail = "RecipesSingleDetail",
    recipesSingleVideo = "RecipesSingleVideo",
    recommendedCard = "RecommendedCard",
    recommendedCardWC = "RecommendedCardWC",
    recommendedCardFeed = "RecommendedCardFeed",
    recommendedDocuments = "RecommendedDocuments",
    recommendedSearch = "RecommendedSearch",
    recommendedSearchBelowSearchBox = "RecommendedSearchBelowSearchBox",
    recommendedSearchCarousel = "RecommendedSearchCarousel",
    recommendedSearchCarouselWC = "RecommendedSearchCarouselWC",
    recommendedSites = "RecommendedSites",
    recommendedSitesWC = "RecommendedSitesWC",
    recommendedTopics = "RecommendedTopics",
    relatedArticleBlock = "RelatedArticleBlock",
    relatedSearchesCard = "RelatedSearchesCard",
    rightRail = "RightRail",
    rightRailCards = "RightRailCards",
    rightRailCarousel = "RightRailCarousel",
    river = "River",
    riverPlaceholder = "RiverPlaceholder",
    searchBoxCommon = "SearchBoxCommon",
    searchBoxEdge = "SearchBoxEdge",
    searchBoxEdgeNext = "SearchBoxEdgeNext",
    searchBoxEdgeNextWC = "SearchBoxEdgeNextWC",
    searchBoxWC = "SearchBoxWC",
    searchHistoryCommon = "SearchHistoryCommon",
    searchHistoryEdge = "SearchHistoryEdge",
    searchHistoryEdgenext = "SearchHistoryEdgenext",
    searchHistoryEdgeNextWC = "SearchHistoryEdgeNextWC",
    seeMoreButtonWindowsShell = "SeeMoreButtonWindowsShell",
    selectCarousel = "SelectCarousel",
    sentimentBarChart = "SentimentBarChart",
    sentimentLineChart = "SentimentLineChart",
    sentimentMap = "SentimentMap",
    sentimentResultCard = "SentimentResultCard",
    serviceWaffle = "ServiceWaffle",
    settingsDialogEdgeNext = "SettingsDialogEdgeNext",
    settingsDialogEdgeNextWC = "SettingsDialogEdgeNextWC",
    settingsDialogMsNews = "SettingsDialogMsNews",
    sharedLinksCard = "SharedLinksCard",
    sharedState = "SharedState",
    sharePointSitesTable = "SharePointSitesTable",
    shopContentCarousel = "ShopContentCarousel",
    shoppingCardWC = "ShoppingCardWC",
    shoppingCarousel = "ShoppingCarousel",
    shoppingCarouselWC = "ShoppingCarouselWC",
    shoppingContentCard = "ShoppingContentCard",
    shoppingGrid = "ShoppingGrid",
    shoppingPage = "ShoppingPage",
    shoppingPageContent = "ShoppingPageContent",
    shoppingSmartList = "ShoppingSmartList",
    shoppingSmartListWC = "ShoppingSmartListWC",
    showFeed = "ShowFeed",
    simpleBanner = "SimpleBanner",
    slideShow = "SlideShow",
    smartList = "SmartList",
    social = "Social",
    socialBar = "SocialBar",
    socialBarWC = "SocialBarWC",
    socialComment = "SocialComment",
    socialProfile = "SocialProfile",
    sportsCard = "SportsCard",
    sportsCardWC = "SportsCardWC",
    sportsMatchupCard = "SportsMatchupCard",
    spotlight = "Spotlight",
    spotlightPreview = "SpotlightPreview",
    starterKit = "StarterKit",
    starterKitWC = "StarterKitWC",
    storyPage = "StoryPage",
    storySnippet = "StorySnippet",
    stripe = "Stripe",
    stripeFeed = "StripeFeed",
    stripeView = "StripeView",
    stripeWC = "StripeWC",
    summaryCard = "SummaryCard",
    summaryCardWC = "SummaryCardWC",
    superAppPage = "SuperAppHomepage",
    superappHeaderData = "SuperappHeaderData",
    tabbedInfopane = "TabbedInfopane",
    tabbedInfopaneTabPreview = "TabbedInfopaneTabPreview",
    taboolaRiver = "TaboolaRiver",
    tasksCard = "TasksCard",
    themePicker = "ThemePicker",
    themePickerWC = "ThemePickerWC",
    tipsCard = "TipsCard",
    toast = "Toast",
    toastWC = "ToastWC",
    todaysEventsCard = "TodaysEventsCard",
    todoCard = "TodoCard",
    todoCardWC = "TodoCardWC",
    topicsHub = "TopicsHub",
    topSites = "TopSites",
    topSitesCommon = "TopSitesCommon",
    topSitesEdge = "TopSitesEdge",
    topSitesEdgeNext = "TopSitesEdgeNext",
    topSitesEdgeNextWC = "TopSitesEdgeNextWC",
    trafficCard = "TrafficCard",
    trafficCardWC = "TrafficCardWC",
    trafficMap = "TrafficMap",
    trafficPage = "TrafficPage",
    travelDestination = "TravelDestination",
    trendingNews = "TrendingNews",
    trendingNow = "TrendingNow",
    trendingNowWC = "TrendingNowWC",
    tripleCard = "TripleCard",
    userInitiatedPageRefresh = "UserInitiatedPageRefresh",
    userProfileDisplay = "UserProfileDisplay",
    verticalLeftNav = "VerticalLeftNav",
    videoCard = "VideoCard",
    videoCardWC = "VideoCardWC",
    videoContent = "VideoContent",
    videoList = "VideoList",
    viewsArticle = "ViewsArticle",
    viewsContentHeader = "ViewsContentHeader",
    viewsGallery = "ViewsGallery",
    viewsNativeAd = "ViewsNativeAd",
    viewsPaddles = "ViewsPaddles",
    voiceSearch = "VoiceSearch",
    voiceSearchWC = "VoiceSearchWC",
    waffleWC = "WaffleWC",
    watch = "Watch",
    watchlistCard = "WatchlistCard",
    watchlistView = "WatchlistView",
    weatherCard = "WeatherCard",
    weatherCardWC = "WeatherCardWC",
    weatherCarousel = "WeatherCarousel",
    weatherData = "WeatherData",
    weatherLocationSearch = "WeatherLocationSearch",
    weatherMap = "WeatherMap",
    weatherMapMini = "WeatherMapMini",
    weatherOverview = "WeatherOverview",
    weatherForecast = "WeatherForecast",
    weatherOverviewV2 = "WeatherOverviewV2",
    weatherPage = "WeatherPage",
    weatherPageV2 = "WeatherPageV2",
    weatherInfoCard = "WeatherInfoCard",
    weatherToast = "WeatherToast",
    weatherTodayCard = "WeatherTodayCard",
    weatherTodayMini = "WeatherTodayMini",
    welcomeGreeting = "WelcomeGreeting",
    welcomeGreetingWC = "WelcomeGreetingWC",
    widgets = "Widgets",
    windowsPage = "WindowsPage",
    windowsShellContentPreview = "WindowsShellContentPreview",
    windowsShellRiver = "WindowsShellRiver",
    ugcCreator = "UgcCreator",
    xfeed = "Xfeed",
    xfeedWC = "XfeedWC"
}
